import roleRoutes from "@/router/modules/rbac/role.js";
import permissionRoutes from "@/router/modules/rbac/permission.js";

const rbacRoutes = [...roleRoutes, ...permissionRoutes];

export default rbacRoutes;
